<div class="container-fluid section-card form p-0">
  <div class="text-left pt-3 ps-3">
    <h3 class="profile-title">Vehículos</h3>
    <span class="sub-title">Estos son los vehículos del prestador</span>
  </div>
  <div class="table-container scrollable-content text-left mt-3">
    <div class="line mt-2"></div>
    @if (!supplierVehicleList) {
      <div class="loadre"></div>
    }
    @if (supplierVehicleList) {
      <table class="table">
        <thead>
          <tr>
            <th class="ps-3">Marca</th>
            <th>Patente</th>
            <th>Seguro</th>
            <th>Modelo</th>
            <th>Color</th>
            <th>Carro</th>
            <th>Patente del carro</th>
            <th>Seguro del carro</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (vehicle of supplierVehicleList; track vehicle) {
            <tr>
              <td class="ps-3">{{ vehicle.brand }}</td>
              <td>{{ vehicle.plateNumber }}</td>
              <td>{{ vehicle.insurance }}</td>
              <td>{{ vehicle.model }}</td>
              <td>{{ vehicle.color }}</td>
              <td>{{ vehicle.trailer }}</td>
              <td>{{ vehicle.trailerPlateNumber }}</td>
              <td>{{ vehicle.trailerInsurance }}</td>
              <td>
                <app-icon-menu-button [menu]="menu" label="Acciones del vehículo"></app-icon-menu-button>
              </td>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="editVehicle(vehicle)">Editar</button>
                <button mat-menu-item (click)="deleteVehicle(vehicle)">
                  Eliminar
                </button>
              </mat-menu>
            </tr>
          }
        </tbody>
      </table>
      @if (vehiclesLoaded && supplierVehicleList.length === 0) {
        <p class="empty-message">Todavía no tiene vehículos cargados.</p>
      }
    }
  </div>
  <div class="footer d-flex justify-content-end">
    <button
      id="addButton"
      class="mt-1 mb-3 me-3"
      (click)="openVehiclesForm()"
      [disabled]="!usrSvc.hasPermission('add:contractor')"
      >
      Agregar Vehículos
    </button>
  </div>
</div>
<div
  class="vehicles-modal d-flex align-items-center justify-content-center w-100"
  [ngClass]="{ expanded: showVehicleForm }"
  >
  @if (showVehicleForm) {
    <div class="modal-container">
      <div class="form-container h-100 mt-4 pb-3 ms-auto me-auto">
        <!-- Title and tabs wrap onto two lines on a phone instead of overlapping. -->
        <div class="vehicle-modal-head">
          <h2 class="vehicle-modal-head__title">
            {{ supplierVehicleToEdit ? "Editar" : "Agregar" }} vehículo
          </h2>
          <div class="vehicle-modal-head__tabs">
            <button
              type="button"
              mat-mdc-raised-button
              [ngClass]="{
                'ind-button': showform == 'info',
                'ind-button-lite': showform == 'documents'
              }"
              (click)="formInfoDocs('info')"
              >
              <span>Información</span>
            </button>
            <button
              type="button"
              mat-mdc-raised-button
              [disabled]="disableDocuments()"
              [ngClass]="{
                'ind-button': showform == 'documents',
                'ind-button-lite': showform == 'info'
              }"
              (click)="formInfoDocs('documents')"
              >
              <span>Documentos</span>
            </button>
          </div>
        </div>
        <div class="line"></div>
        <form [formGroup]="supplierVehicleForm" class="px-4" autocomplete="off">
          <div class="mb-4 pt-4">
            <span>{{
              supplierVehicleToEdit
              ? "Edita los datos del vehículo seleccionado"
              : "Ingrese los datos del vehículo"
            }}</span>
          </div>
          @if (showInfoContent) {
            <div>
              <div class="row px-3 my-3">
                <label class="ps-0 pb-2" for="brand">Marca </label>
                <input
                  matInput
                  name="brand"
                  formControlName="brand"
                  required
                  maxlength="30"
              [class]="{
                error:
                  supplierVehicleForm.get('brand')?.touched &&
                  supplierVehicleForm.get('brand')?.hasError('required')
              }"
                  />
                  @if (
                    supplierVehicleForm.get('brand')?.touched &&
                    supplierVehicleForm.get('brand')?.hasError('required')
                    ) {
                    <mat-error
                      class="ps-0"
                      >
                      Campo obligatorio.
                    </mat-error>
                  }
                </div>
                <div class="row px-3 my-3">
                  <label class="ps-0 pb-2" for="model">Modelo </label>
                  <input
                    matInput
                    name="model"
                    formControlName="model"
                    required
                    maxlength="30"
              [class]="{
                error:
                  supplierVehicleForm.get('model')?.touched &&
                  supplierVehicleForm.get('model')?.hasError('required')
              }"
                    />
                    @if (
                      supplierVehicleForm.get('model')?.touched &&
                      supplierVehicleForm.get('model')?.hasError('required')
                      ) {
                      <mat-error
                        class="ps-0"
                        >
                        Campo obligatorio. No se permiten caracteres extraños.
                      </mat-error>
                    }
                  </div>
                  <div class="row px-3 my-3">
                    <label class="ps-0 pb-2" for="plateNumber">Patente</label>
                    <input
                      matInput
                      name="plateNumber"
                      formControlName="plateNumber"
                      required
                      maxlength="9"
              [class]="{
                error:
                  supplierVehicleForm.get('plateNumber')?.touched &&
                  supplierVehicleForm.get('plateNumber')?.hasError('required')
              }"
                      />
                      @if (
                        supplierVehicleForm.get('plateNumber')?.touched &&
                        supplierVehicleForm.get('plateNumber')?.hasError('required')
                        ) {
                        <mat-error
                          class="ps-0"
                          >
                          Campo obligatorio.
                        </mat-error>
                      }
                    </div>
                    <div class="row px-3 my-3">
                      <label class="ps-0 pb-2" for="color">Color</label>
                      <input
                        matInput
                        name="color"
                        formControlName="color"
                        required
                        maxlength="30"
              [class]="{
                error:
                  supplierVehicleForm.get('color')?.touched &&
                  supplierVehicleForm.get('color')?.hasError('required')
              }"
                        />
                        @if (
                          supplierVehicleForm.get('color')?.touched &&
                          supplierVehicleForm.get('color')?.hasError('required')
                          ) {
                          <mat-error
                            class="ps-0"
                            >
                            Campo obligatorio.
                          </mat-error>
                        }
                      </div>
                      <div class="row px-3 my-3">
                        <label class="ps-0 pb-2" for="insurance">Seguro</label>
                        <input
                          matInput
                          name="insurance"
                          formControlName="insurance"
                          required
                          maxlength="30"
              [class]="{
                error:
                  supplierVehicleForm.get('insurance')?.touched &&
                  supplierVehicleForm.get('insurance')?.hasError('required')
              }"
                          />
                          @if (
                            supplierVehicleForm.get('insurance')?.touched &&
                            supplierVehicleForm.get('insurance')?.hasError('required')
                            ) {
                            <mat-error
                              class="ps-0"
                              >
                              Campo obligatorio.
                            </mat-error>
                          }
                        </div>
                        <div class="row px-3 my-3">
                          <label class="ps-0 pb-2" for="trailer">Carro </label>
                          <input
                            matInput
                            name="trailer"
                            formControlName="trailer"
                            maxlength="30"
                            />
                          </div>
                          <div class="row px-3 my-3">
                            <label class="ps-0 pb-2" for="trailerPlateNumber"
                              >Patente del carro
                            </label>
                            <input
                              matInput
                              name="trailerPlateNumber"
                              formControlName="trailerPlateNumber"
                              maxlength="13"
                              />
                            </div>
                            <div class="row px-3 my-3">
                              <label class="ps-0 pb-2" for="trailerInsurance"
                                >Seguro del carro
                              </label>
                              <input
                                matInput
                                name="trailerInsurance"
                                formControlName="trailerInsurance"
                                maxlength="30"
                                />
                              </div>
                            </div>
                          }
                          @if (!showInfoContent) {
                            <div class="supplierVehicleForm">
                              <div class="row mt-4">
                                <app-file-uploader
                                  [description]="'Foto de la patente del vehículo'"
                                  [name]="'patentImg'"
                                  [settings]="uploadersetting"
                                  >
                                </app-file-uploader>
                              </div>
                              <div class="row mt-4">
                                <app-file-uploader
                                  [description]="'Foto del carro'"
                                  [name]="'trailerPhotoImg'"
                                  [settings]="uploadersetting"
                                  >
                                </app-file-uploader>
                              </div>
                              <div class="row mt-4">
                                <app-file-uploader
                                  [description]="'Foto frontal del vehículo'"
                                  [name]="'frontPhotoImg'"
                                  [settings]="uploadersetting"
                                  >
                                </app-file-uploader>
                              </div>
                              <div class="row mt-4">
                                <app-file-uploader
                                  [description]="'Foto patente del carro'"
                                  [name]="'trailerPatentImg'"
                                  [settings]="uploadersetting"
                                  >
                                </app-file-uploader>
                              </div>
                              <div class="row mt-4">
                                <app-file-uploader
                                  [description]="'Foto lateral del vehículo'"
                                  [name]="'sidePhotoImg'"
                                  [settings]="uploadersetting"
                                  >
                                </app-file-uploader>
                              </div>
                            </div>
                          }
                        </form>
                        <div class="line"></div>
                        <div class="row buttons-footer justify-content-end me-4">
                          <button
                            class="ind-button-lite float-right"
                            (click)="closeVehiclesForm()"
                            style="width: 100px !important"
                            >
                            <span>Cancelar</span>
                          </button>
                          <button
                            mat-mdc-raised-button
                            class="ind-button float-right"
                            type="button"
                            (click)="onSubmit()"
                            >
                            <span>Guardar cambios</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
